(function(){
  const THRESHOLD = 999; // MXN
  const CURRENCY  = 'MXN';
  const $wrap  = document.getElementById('fs-progress');
  if(!$wrap) return;

  const $fill  = $wrap.querySelector('.fs__bar-fill');
  const $label = $wrap.querySelector('[data-fs-percent]');
  const $msg   = $wrap.querySelector('[data-fs-msg]');

  // -------- Helpers --------
  const money = n => n.toLocaleString('es-MX',{style:'currency',currency:CURRENCY,maximumFractionDigits:0});
  const clamp = (v,min,max)=>Math.max(min,Math.min(max,v));
  const debounce = (fn,ms)=>{ let t; return (...a)=>{ clearTimeout(t); t=setTimeout(()=>fn(...a),ms); }; };

  async function getCart(){
    const res = await fetch('/cart.js', {credentials:'same-origin', cache:'no-store'});
    return res.json();
  }

  function render(cart){
    $wrap.classList.remove('hidden');
    const items = cart.item_count|0;
    const subtotal = (cart.total_price|0)/100;

    if(items === 0){
      // Carrito vacío
      $wrap.classList.remove('fs--done');
      $fill.style.width = '0%';
      $label.textContent = '0%';
      $msg.innerHTML = `Agrega ${money(THRESHOLD)} para tener <strong>ENVÍO GRATIS</strong>`;
      return;
    }

    const pct = clamp(Math.round((subtotal/THRESHOLD)*100),0,100);
    const remaining = Math.max(0, THRESHOLD - subtotal);

    $fill.style.width = pct + '%';
    $label.textContent = pct + '%';

    if(remaining > 0){
      $wrap.classList.remove('fs--done');
      $msg.innerHTML = `Agrega ${money(remaining)} para tener <strong>ENVÍO GRATIS</strong>`;
    } else {
      $wrap.classList.add('fs--done');
      $msg.innerHTML = `¡Tienes <strong>ENVÍO GRATIS</strong>!`;
    }
  }

  const updateFS = debounce(async ()=>{
    try { render(await getCart()); } catch(e){ console.error('[fs-progress]', e); }
  }, 120);

  // -------- Disparadores robustos --------
  // 1) Al cargar
  document.addEventListener('DOMContentLoaded', updateFS);

  // 2) Formularios típicos
  document.addEventListener('submit', (ev)=>{
    const action = ev.target?.action || '';
    if(/\/cart\/(add|change|update)/.test(action)) setTimeout(updateFS, 120);
  });

  // 3) Clicks típicos (añadir/eliminar)
  document.addEventListener('click', (e)=>{
    const el = e.target.closest('button, a, [type="submit"], [data-action]');
    if(!el) return;
    if(
      el.closest('form[action*="/cart/add"]') ||
      el.closest('form[action*="/cart/change"]') ||
      el.closest('form[action*="/cart/update"]') ||
      el.matches('[data-cart-remove], .cart__remove, .remove, [name="clear"], [data-action="decrement"], [data-action="increment"]')
    ){
      setTimeout(updateFS, 150);
    }
  });

  // 4) Eventos personalizados comunes
  ['cart:updated','cart:change','ajaxCart:updated','cart:emptied','drawer:cart:updated']
    .forEach(evt=>document.addEventListener(evt, updateFS));

  // 5) Observar el drawer/mini-cart (si existe) para cambios DOM
  const drawers = ['#cart-drawer','.cart-drawer','.mini-cart','.ajaxcart','.side-cart'];
  drawers.forEach(sel=>{
    const node = document.querySelector(sel);
    if(!node) return;
    new MutationObserver(()=>setTimeout(updateFS, 60)).observe(node, {childList:true, subtree:true});
  });

  // 6) Interceptar TODAS las llamadas a /cart/* (fetch + XHR)
  try {
    const _fetch = window.fetch;
    window.fetch = async function(...args){
      const res = await _fetch.apply(this, args);
      try {
        const url = (typeof args[0]==='string' ? args[0] : (args[0]?.url || '')) + '';
        if(/\/cart(\/|\.js)/.test(url)) setTimeout(updateFS, 60);
      } catch(_) {}
      return res;
    };

    const _open = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function(method, url, ...rest){
      this.__isCart = /\/cart(\/|\.js)/.test(String(url||''));
      this.addEventListener('load', ()=>{ if(this.__isCart) setTimeout(updateFS, 60); });
      return _open.call(this, method, url, ...rest);
    };
  } catch(e){ /* noop */ }

  // 7) Si el drawer está abierto, hacemos un micro-poll mientras tanto
  let pollId = null;
  function startPoll(){ if(pollId) return; pollId = setInterval(updateFS, 900); }
  function stopPoll(){ clearInterval(pollId); pollId = null; }

  document.addEventListener('cart:drawer:open', startPoll);
  document.addEventListener('cart:drawer:close', stopPoll);
  document.addEventListener('visibilitychange', ()=>{ if(document.hidden) stopPoll(); });

  // 8) Seguridad: mostrar por si quedó oculto
  setTimeout(()=> $wrap.classList.remove('hidden'), 0);
})();